module.exports = __webpack_public_path__ + "static/media/product9.629827fe.jpg";